import { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import ValidateIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import { getCurrentFunctionName } from '../../performanceModeManager';
import InterventionReportBloc from './InterventionReportBloc';
import { setUpdatingBloc } from '../../redux/intervention/interventionActions';
import Typography from '@mui/material/Typography';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class UpdatingBlocModal extends Component {

    close() {
        this.props.clearUpdatingBloc();
    }

    onBlocClick() {

    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        if (!this.props.updatingBloc || this.props.updatingBloc.validated)
            return null;

        let blocType = this.props.blocTypes.find((bt) => bt.id === this.props.updatingBloc.type_id);

        if (!blocType) {
            console.error("Le type de bloc est introuvable");
            return;
        }

        return (
            <Dialog aria-labelledby="simple-dialog-title" open={this.props.updatingBloc !== null && this.props.updatingBloc !== undefined}
                onClose={this.close.bind(this)} fullScreen>
                <AppBar className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            {"Modifier un bloc"}
                        </Typography>
                        <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                            <ValidateIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Toolbar/>
                <DialogContent className="without-side-padding">
                    <InterventionReportBloc id={"updating-bloc" + this.props.updatingBloc.type_id}
                        currentBlocId={this.props.updatingBloc.mobile_id} expanded={true}
                        blocType={blocType} onClick={this.onBlocClick}
                        fieldValueChange={this.props.fieldValueChange.bind(this)} validated={this.props.updatingBloc.validated} signed_by_customer={this.props.updatingBloc.signed_by_customer} />
                </DialogContent>
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearUpdatingBloc: () => dispatch(setUpdatingBloc(null)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(UpdatingBlocModal);
